import React, { useState, useEffect, useMemo } from "react";
import { TextArea, NumericTextBox, Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { useNominalsBySubType } from "services/nominalsService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import { useSelector, useDispatch } from "react-redux";
import MattersCombobox from "../Postings/MattersComboBox";
import Modalposting from "../Postings/PostingModal";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { FILES_CONTEXT, useFiles } from "services/filesDownloadService";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { ComboBoxComponent } from "pages/ChitRequest/ChitRequestComponents";
import styles from "pages/ChitRequest/ChitRequest.module.scss";
import { getMatterAllInfo } from "api";
import { editPosting } from "api/accountsAPI";
import { formatDateForAPI } from "components/common/formatter";
import { toast } from "react-toastify";
import { useActiveVats } from "services/vatService";
import { useActiveFeeEarner } from "services/userService";
import { useActiveSuppliers } from "services/supplierService";
import { useActiveBranches } from "services/branchService";
import chitRequestFieldsConfig from "pages/ChitRequest/chit_request_fields.json";
import {
  isNonMatterPostingType,
  normalizePostingType,
} from "CONSTANT/Matter/PostingTypes";

const displayFieldsFor = (postingType) => {
  const code = normalizePostingType(postingType);
  return chitRequestFieldsConfig.data.find(
    (item) => normalizePostingType(item.code) === code
  )?.displayFields;
};

export const isPostingTypeEditable = (postingType) =>
  Boolean(displayFieldsFor(postingType));

const asDisplayOnly = (ref) => (ref ? { display: ref } : null);

const resolveNominalValue = (nominals, ref) =>
  nominals?.find((n) => n.nominalRef === ref) ?? asDisplayOnly(ref);

const EditPosting = (props) => {
  const { postingInfo } = props;
  const { data: activevatsdata = [] } = useActiveVats();
  const [resetDocs, setresetDocs] = useState(false);
  const { clearFile } = useFiles(FILES_CONTEXT.CHIT_REQUEST);

  const date = new Date();
  const [type, settype] = useState("");
  const [selectedVat, setSelectedVat] = useState(null);
  const resolvedVat = useMemo(
    () =>
      activevatsdata.find(
        (v) => String(v.vatCodeId) === String(postingInfo.vatCode)
      ) ?? null,
    [activevatsdata, postingInfo.vatCode]
  );
  const vatvalue = selectedVat ?? resolvedVat;
  const [matterref, setmatterref] = useState(postingInfo.matterID || null);
  const [feeearnerref, setfeeearnerref] = useState();
  const [matter, setMatter] = useState("");
  const [branch, setbranch] = useState({ branchId: "" });
  const [nominal, setnominal] = useState({ nominalRef: "" });
  const [suppliervalue, setsuppliervalue] = useState({ supplierRef: "" });
  const [errorModal, setErrorModal] = useState(false);
  const [officevalue, setofficevalue] = useState(postingInfo?.officeBank || "");
  const [clientvalue, setclientvalue] = useState(postingInfo?.clientBank || "");
  const [ddavalue, setddavalue] = useState(postingInfo?.ddaBank || "");
  const [reference, setreference] = useState(postingInfo?.reference || "");
  const [payee, setpayee] = useState(postingInfo?.payee || "");
  const [payer, setpayer] = useState(postingInfo?.payer || "");
  const [vatamount, setvatamount] = useState(postingInfo?.vatAmount || 0);
  const [netamount, setnetamount] = useState(postingInfo?.netAmount || 0);
  const { data: suppliersdata } = useActiveSuppliers();
  const { data: branchesData } = useActiveBranches();
  const [grossamount, setgrossamount] = useState("");
  const [resetmatter, setresetmatter] = useState(false);
  const [details, setdetails] = useState(postingInfo?.details || "");
  const [dateselector, setdateselector] = useState(
    new Date(postingInfo?.date) || date
  );
  const [counselfee, setcounselfee] = useState(
    postingInfo?.isCounselFee || false
  );
  const [statepreserver, setstatepreserver] = useState(false);
  const [modalvalue, setmodalvalue] = useState(false);
  const [validation_message, setvalidation_message] = useState(false);
  const [documentUpload, setDocumentsUpload] = useState(false);
  const [value, setValue] = useState("");
  const dispatch = useDispatch();

  const isNonMatterPosting = isNonMatterPostingType(postingInfo?.postingType);

  const list = useMemo(
    () =>
      (displayFieldsFor(postingInfo?.postingType) ?? []).map(
        (item) => item.name
      ),
    [postingInfo?.postingType]
  );

  const onChange = (event) => {
    setValue(event.value);
  };
  const onChangesupplier = (event) => {
    if (event !== undefined && event !== null) {
      setsuppliervalue(event.value);
    }
  };
  const onChangeofficebank = (event) => {
    if (event !== undefined && event !== null) {
      setofficevalue(event.value);
    }
  };
  const onChangeclientbank = (event) => {
    if (event !== undefined && event !== null) {
      setclientvalue(event.value);
    }
  };
  const onChangeddabank = (event) => {
    if (event !== undefined && event !== null) {
      setddavalue(event.value);
    }
  };
  const { data: feeearnerdata } = useActiveFeeEarner();

  useEffect(() => {
    getMatterInfo();
    feeEarnerValue();
  }, []);
  // set Initial feeEarner value
  const feeEarnerValue = () => {
    if (postingInfo.feeEarnerRef !== null) {
      const feeEarner = feeearnerdata.find(
        (item) => item.userRef === postingInfo.feeEarnerRef
      );
      setfeeearnerref(feeEarner);
    }
    return null;
  };

  const getMatterInfo = async () => {
    if (!postingInfo?.matterID) return;

    try {
      const matterInfo = await getMatterAllInfo(postingInfo.matterID);
      setMatter(matterInfo.data.data);
    } catch (error) {
    }
  };

  const { data: officeNominals } = useNominalsBySubType(
    "BalanceSheet_OfficeBank",
    { excludeArchived: true },
  );
  const { data: clientNominals } = useNominalsBySubType(
    "BalanceSheet_ClientBank",
    { excludeArchived: true },
  );
  const { data: ddaNominals } = useNominalsBySubType("BalanceSheet_DDABank", {
    excludeArchived: true,
  });

  const officeapidata = officeNominals || [];
  const clientapidata = clientNominals || [];
  const ddaapidata = ddaNominals || [];

  const { data: expenseNominals } = useNominalsBySubType(
    "ProfitAndLoss_Expense",
    { excludeArchived: true },
  );
  const nominallist = expenseNominals || [];

  useEffect(() => {
    if (statepreserver === false) {
      setTimeout(() => {
        setvatsData(activevatsdata.slice());
        setfeeearnerData(feeearnerdata.slice());
        setsuppliersdata(suppliersdata.slice());
        setnominaldata(nominallist.slice());
        setofficedata(officeapidata.slice());
        setclientdata(clientapidata.slice());
        setddadata(ddaapidata.slice());
        setstatepreserver(true);
      }, 2000);
    }
  }, [
    feeearnerdata,
    activevatsdata,
    suppliersdata,
    officeapidata,
    clientapidata,
    ddaapidata,
  ]);

  const [vatsdata, setvatsData] = useState();
  const [feeearner, setfeeearnerData] = useState();
  const [suppliers, setsuppliersdata] = useState();
  const [nominaldata, setnominaldata] = useState();
  const [officedata, setofficedata] = useState();
  const [clientdata, setclientdata] = useState();
  const [ddadata, setddadata] = useState();

  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };
  const filtersupplier = (filter) => {
    const data = suppliersdata.slice();
    return filterBy(data, filter);
  };
  const filterChangesupplier = (event) => {
    setsuppliersdata(filtersupplier(event.filter));
  };

  const filterofficebank = (filter) => {
    const data = officeapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeofficebank = (event) => {
    setofficedata(filterofficebank(event.filter));
  };
  const filterclientbank = (filter) => {
    const data = clientapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeclientbank = (event) => {
    setofficedata(filterclientbank(event.filter));
  };
  const filterddabank = (filter) => {
    const data = ddaapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeddabank = (event) => {
    setofficedata(filterddabank(event.filter));
  };
  const filterfeeearnerData = (filter) => {
    const data = feeearnerdata.slice();
    return filterBy(data, filter);
  };
  const filterfeeearner = (event) => {
    setfeeearnerData(filterfeeearnerData(event.filter));
  };
  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };

  const calculatevatamount = (vat, net) => {
    if (vat == null) return;
    const rate = vat.rate ?? 0;
    const calculated = Number(net || 0) * (rate / 100);
    setvatamount(Number.isFinite(calculated) ? calculated : 0);
  };

  const onChangevat = (event) => {
    const nextVat = event.value;
    setSelectedVat(nextVat);
    if (nextVat == null) {
      setvatamount(0);
      return;
    }
    calculatevatamount(nextVat, netamount);
    setvatsData(activevatsdata.slice());
  };

  useEffect(() => {
    calculatevatamount(vatvalue, netamount);
  }, [vatvalue, netamount]);

  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };

  const onChangenominal = (event) => {
    setnominal(event.value);
  };

  const closeDialog = () => {
    props.cancelViewPosting();
    props.cancelEdit();
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    // if (props.name === undefined) {
    //   if (filesChitRequest[0] !== undefined) {
    //     const docsId = [];
    //     filesChitRequest.map((item) => {
    //       docsId.push(item.fileID);
    //     });
    // data[0].DocumentFiles = docsId;
    //   }
    // }
    // if (IS_MODAL) {
    // data[0].matterID = props.matter?.matterId;
    // }
    // dispatch(createposting(data));

    const data = {
      date: formatDateForAPI(dateselector),
      reference: reference,
      netAmount: netamount,
      vatAmount: vatamount,
      vatCode: vatvalue?.vatCodeId ?? postingInfo?.vatCode,
      vatRate: vatvalue?.rate ?? postingInfo?.vatRate,
      details: details,
      transactionPeriod: postingInfo?.transactionPeriod,
      isCounselFee: counselfee,
      payer: payer,
      payee: payee,
      officeBank: officevalue,
      clientBank: clientvalue || "",
      ddaBank: ddavalue || "",
      costCentre: postingInfo?.costCentre,
      documentFiles: postingInfo?.documentFiles,
      //   postedDocuments: [
      //     {
      //       documentId: 0,
      //       active: true,
      //     },
      //   ],
    };
    if (!isNonMatterPosting) {
      data.feeEarnerRef = feeearnerref?.userRef;
    }
    try {
      await editPosting(props?.transNo, data);
      closeDialog();
      props.reloadPosting();
      toast.success("Posting edited successfully");
    } catch (error) {
    }
  };
  const resetfields = () => {
    setvalidation_message(false);
    setgrossamount("");
    setreference("");
    setvatamount("");
    // setmatterref(undefined);
    setpayee("");
    setpayer("");
    setdetails("");
    setnetamount(0);
    setfeeearnerref(null);
    setdateselector(date);
    setSelectedVat(null);
    setofficevalue(null);
    setclientvalue(null);
    setddavalue(null);
    setsuppliervalue({ supplierRef: "" });
    setnominal({ nominalRef: "" });
    setbranch({ branchId: "" });
    setsuppliersdata(suppliersdata.slice());
    setvatsData(activevatsdata.slice());
    setfeeearnerData(feeearnerdata.slice());
    setresetDocs(!resetDocs);
    setcounselfee(false);
    clearFile();
  };

  const { isSuccess, uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = React.useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);

    const parameters = {
      documentType: "Posting",
      matterId: postingInfo.matterID || "",
      supplierRef: suppliervalue.supplierRef || "",
      nominalRef: nominal.nominalRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
  };
  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const resolvedSupplier = useMemo(
    () =>
      suppliersdata?.find((s) => s.supplierRef === postingInfo?.supplierRef) ??
      asDisplayOnly(postingInfo?.supplierRef),
    [suppliersdata, postingInfo?.supplierRef]
  );

  const resolvedNominal = useMemo(
    () => resolveNominalValue(expenseNominals, postingInfo?.nominalRef),
    [expenseNominals, postingInfo?.nominalRef]
  );

  const resolvedOfficeBank = useMemo(
    () => resolveNominalValue(officeNominals, postingInfo?.officeBank),
    [officeNominals, postingInfo?.officeBank]
  );

  const resolvedOfficeBankTo = useMemo(
    () => resolveNominalValue(officeNominals, postingInfo?.officeBankTo),
    [officeNominals, postingInfo?.officeBankTo]
  );

  const resolvedClientBank = useMemo(
    () => resolveNominalValue(clientNominals, postingInfo?.clientBank),
    [clientNominals, postingInfo?.clientBank]
  );

  const resolvedDdaBank = useMemo(
    () => resolveNominalValue(ddaNominals, postingInfo?.ddaBank),
    [ddaNominals, postingInfo?.ddaBank]
  );

  const resolvedBranch = useMemo(
    () => branchesData?.find((b) => b.branchId === postingInfo?.branchId) ?? null,
    [branchesData, postingInfo?.branchId]
  );

  const comboBoxesInfo = [
    {
      key: "OfficeBank",
      label: isNonMatterPosting && list.includes("OfficeBankTo")
        ? "From Bank"
        : "Office Bank",
      condition: officevalue === undefined,
      data: officedata,
      disabled: true,
      value: resolvedOfficeBank,
      placeholder: "Search Office Bank",
    },
    {
      key: "OfficeBankTo",
      label: "To Bank",
      data: officedata,
      disabled: true,
      value: resolvedOfficeBankTo,
      placeholder: "To Bank",
    },
    {
      key: "SupplierRef",
      label: "Supplier Ref",
      condition: suppliervalue.supplierRef === "",
      data: suppliers,
      onFilterChange: filterChangesupplier,
      value: resolvedSupplier,
      field: "display",
      onChange: onChangesupplier,
      disabled: true,
      placeholder: "Search Supplier Ref",
    },
    {
      key: "ClientBank",
      label: "Client Bank",
      condition: clientvalue === undefined,
      data: clientdata,
      onFilterChange: filterChangeclientbank,
      value: resolvedClientBank,
      onChange: onChangeclientbank,
      disabled: true,
      placeholder: "Search Client Bank",
    },
    {
      key: "DDABank",
      label: "DDA Bank",
      condition: ddavalue === undefined,
      data: ddadata,
      onFilterChange: filterChangeddabank,
      value: resolvedDdaBank,
      onChange: onChangeddabank,
      disabled: true,
      placeholder: "Search DDA Bank",
    },
    {
      key: "NominalRef",
      label: "Nominal Ref",
      condition: nominal.nominalRef === "",
      data: nominaldata,
      onFilterChange: filternominal,
      value: resolvedNominal,
      onChange: onChangenominal,
      disabled: true,
      placeholder: "Search Nominal Ref",
    },
    {
      key: "BranchId",
      label: "Branch",
      data: branchesData,
      value: resolvedBranch,
      disabled: true,
      placeholder: "Branch",
    },
  ];

  const EditPostingContent = () => {
    return (
      <div className={`h-100 ${styles["main-container"]}`}>
        <div className="bgForm overflow-auto">
          <div
            className="px-lg-5 px-3 "
            style={{
              maxHeight: "auto",
              maxWidth: "950px",
              overflow: "auto",
            }}
          >
            <form onSubmit={handlesubmit}>
              <div className="mt-4 px-2">
                <div className="d-flex gap-5 align-items-stretch">
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">Posting Type</Label>
                      <DropDownList
                        className={`${styles["input-styles"]}`}
                        iconClassName="wa"
                        value={`${postingInfo.postingType} - ${props.postingName}`}
                        disabled
                      />
                    </div>
                    {!isNonMatterPosting && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Matter</Label>
                        <MattersCombobox
                          className={`${styles["input-styles"]}`}
                          disabled
                          error={validation_message && !matterref}
                          value={matter}
                        />
                      </div>
                    )}
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">Date</Label>
                      <DatePicker
                        className={`${styles["input-styles"]} px-2`}
                        value={dateselector}
                        onChange={onChangedateselect}
                        toggleButton={CalenderCustomToggleButton}
                      />
                    </div>
                    {list.includes("Reference") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Reference</Label>
                        <Input
                          className={`${styles["input-styles"]}`}
                          value={reference}
                          onChange={(e) => {
                            setreference(e.target.value);
                          }}
                          placeholder={"Add Reference"}
                        />
                      </div>
                    )}
                    {comboBoxesInfo.map(
                      ({
                        key,
                        label,
                        condition,
                        data,
                        onFilterChange,
                        value,
                        onChange,
                        field,
                        placeholder,
                        disabled,
                      }) =>
                        list.includes(key) ? (
                          <ComboBoxComponent
                            key={key}
                            label={label}
                            className={`${styles["input-styles"]}`}
                            data={data}
                            textField={field || "display"}
                            filterable={true}
                            onFilterChange={onFilterChange}
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            disabled={disabled}
                          />
                        ) : null
                    )}
                  </div>

                  <div className="d-flex flex-column gap-3 justify-content-end">
                    {list.includes("NetAmount") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Net amount</Label>
                        <NumericTextBox
                          value={netamount}
                          className={`${styles["input-styles"]} right-align`}
                          disabled
                          spinners={false}
                          format="n2"
                          placeholder="0.00"
                        />
                      </div>
                    )}
                    {(list.includes("VatCode") || list.includes("VatAmount")) && (
                      <div className="d-flex gap-3">
                        {list.includes("VatCode") && (
                          <div className="d-flex flex-column">
                            <Label className="label mb-1">VAT</Label>
                            <ComboBox
                              className={`${styles["small-inputbox"]}`}
                              data={activevatsdata}
                              textField={"display"}
                              filterable={true}
                              onFilterChange={filterChange}
                              value={vatvalue}
                              onChange={onChangevat}
                              placeholder={"Code"}
                            />
                          </div>
                        )}
                        {list.includes("VatAmount") && (
                          <div className="d-flex flex-column">
                            <Label className="label mb-1">VAT Amount</Label>
                            <NumericTextBox
                              className={`${styles["small-inputbox"]} right-align`}
                              value={vatamount}
                              readOnly={true}
                              placeholder="0.00"
                              spinners={false}
                              format="n2"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {list.includes("FeeEarnerRef") && !isNonMatterPosting && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Fee Earner</Label>
                        <ComboBox
                          className={`${styles["input-styles"]}`}
                          data={feeearner}
                          iconClassName="wa"
                          textField={`display`}
                          filterable
                          onFilterChange={filterfeeearner}
                          placeholder={"Search Fee Earner"}
                          value={feeearnerref}
                          onChange={onChangefeeearner}
                        />
                      </div>
                    )}
                    {list.includes("Payer") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Payer</Label>
                        <div className="validator">
                          <Input
                            value={payer}
                            className={`${styles["input-styles"]}`}
                            onChange={(e) => {
                              setpayer(e.target.value);
                            }}
                            placeholder={"Add Payer"}
                          ></Input>
                        </div>
                      </div>
                    )}
                    {list.includes("Payee") && (
                      <div className="d-flex flex-column">
                        <Label className="label mb-1">Payee</Label>
                        <div className="validator">
                          <Input
                            className={`${styles["input-styles"]}`}
                            value={payee}
                            onChange={(e) => {
                              setpayee(e.target.value);
                            }}
                            placeholder={"Add Payee"}
                          ></Input>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-column mt-3">
                  <Label className="label mb-1">Details</Label>
                  <TextArea
                    value={details}
                    className={`${styles["details-textbox"]}`}
                    rows={5}
                    multiple={true}
                    placeholder="Enter Details"
                    onChange={(e) => {
                      setdetails(e.target.value);
                    }}
                  />
                </div>

                <div className="mt-3 d-flex justify-content-start">
                  <DocumentsUpload
                    open={documentUpload}
                    value={postingInfo?.postingType}
                    type={"Edit Posting"}
                    resetDocs={resetDocs}
                    progress={progress}
                    filesData={filesData}
                    onFileRemove={onFileRemove}
                    onError={() => {
                      const newFiles = filesData.splice(filesData.length, 1);
                      setFilesData([...newFiles]);
                    }}
                    onUpload={handleUpload}
                  />
                </div>
              </div>
              <Modalposting
                value={modalvalue}
                reset={() => {
                  resetfields();
                }}
                closeModal={() => {
                  setmodalvalue(false);
                  props.cancelEdit();
                }}
                component={"Posting"}
              />
            </form>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      title={"Edit Posting"}
      onClose={props.cancelEdit}
      className="dialog-xmd"
    >
      {EditPostingContent()}
      <DialogActionsBar>
        <div className={`float-end w-100 dialog-footer`}>
          <Button
            className="common-btn bgBtnSecondary me-3"
            type="button"
            onClick={() => {
              //   resetfields();
              props.cancelEdit();
            }}
          >
            Cancel
          </Button>
          <Button
            className="common-btn me-3"
            type="submit"
            id="chit-request-post"
            onClick={handlesubmit}
          >
            Update
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};
export default EditPosting;
